import { render, staticRenderFns } from "./DataCollector.vue?vue&type=template&id=25eac6f8&scoped=true"
import script from "./DataCollector.vue?vue&type=script&lang=js"
export * from "./DataCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eac6f8",
  null
  
)

export default component.exports